module.exports = __webpack_public_path__ + "static/assets/cf21e9b36c0dfd5debc399d6fbf5d2c9.svg";